import { render, staticRenderFns } from "./ProductLabelEditImageForm.vue?vue&type=template&id=3c13e82a&scoped=true&"
import script from "./ProductLabelEditImageForm.vue?vue&type=script&lang=js&"
export * from "./ProductLabelEditImageForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelEditImageForm.vue?vue&type=style&index=0&id=3c13e82a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13e82a",
  null
  
)

export default component.exports